import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-18137 Просмотр ВК файлов в R7
 */
export const R7_EMBEDDED = getFeature('r7-embedded') || false;

// Логировать конфиги просмотрщика при попытке открыть МойОфис, чтобы понять откуда трафик
export const LOG_MYOFFICE_OPEN_ATTEMPTS = getFeature('log-myoffice-open-attempts') || false;

export const DISABLE_MYOFFICE_EMBEDDED = getFeature('disable-myoffice-embedded') || false;
